import { getEnvConfig } from 'src/helpers/config';
import { useUserStore } from 'src/stores/user';

export const sendGAEvent = (event: string, payload: Record<string, string>, withFilterByAdmin = true) => {
  const { gtm } = getEnvConfig();

  if (withFilterByAdmin ? !useUserStore.getState().user?.isAdmin : true) {
    if (import.meta.env.VITE_PROJECT_ENV !== 'production') {
      console.log(`GA: ${event} ${JSON.stringify(payload)}`);
    }

    if (gtm) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event,
        ...payload,
      });
    }
  }
};
